
import { Vue } from "vue-class-component";

export default class MapsPin extends Vue {}
